(() => {
  if (window.mndjCustomOptionsInstalled) return;
  window.mndjCustomOptionsInstalled = true;
  const root = document.querySelector('product-info[data-product-id="8788827537736"]');
  const labels = (() => {
    try { return JSON.parse(document.querySelector('#mndj-custom-i18n')?.textContent || '{}'); }
    catch { return {}; }
  })();
  if (!root) return;
  const requiredNames = ['properties[Photo de face (obligatoire)]', 'properties[Photo 1 des vêtements (obligatoire)]'];
  const options = () => [...root.querySelectorAll('input[name^="properties["], textarea[name^="properties["]')];
  const repair = () => {
    options().forEach(input => {
      const name = input.name.slice(11, -1);
      const label = input.type === 'radio' ? `${name} : ${input.value}` : name;
      if (input.getAttribute('aria-label') !== label) input.setAttribute('aria-label', label);
      const labelledBy = input.getAttribute('aria-labeledby');
      if (labelledBy) {
        input.setAttribute('aria-labelledby', labelledBy);
        input.removeAttribute('aria-labeledby');
      }
      if (input.type === 'file' && requiredNames.includes(input.name)) input.required = true;
    });
    root.querySelectorAll('option').forEach(option => {
      if (option.textContent.trim() === 'Choose one') option.textContent = labels.chooseOne || 'Choisissez une option';
    });
    root.querySelectorAll('*').forEach(element => {
      const text = element.textContent.trim();
      const isSummary = /^Selection will add\s+.*\s+to the price$/.test(text);
      const childContainsSummary = [...element.children].some(child =>
        /^Selection will add\s+.*\s+to the price$/.test(child.textContent.trim())
      );
      if (isSummary && !childContainsSummary) {
        element.textContent = text
          .replace(/^Selection will add\s+/, labels.pricePrefix || 'La sélection ajoute ')
          .replace(/\s+to the price$/, labels.priceSuffix || ' au prix');
      }
    });
  };
  const validate = event => {
    const controls = options();
    const missing = requiredNames.filter(name => !controls.some(input => input.name === name &&
      (input.type === 'file' ? input.files?.length > 0 : input.type === 'hidden' && input.value.trim())));
    if (!missing.length) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const error = root.querySelector('[data-mndj-photo-error]');
    if (error) {
      error.hidden = false;
      error.focus();
    }
    const input = controls.find(input => missing.includes(input.name) && input.type === 'file');
    input?.setAttribute('aria-invalid', 'true');
    input?.focus();
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[name="add"], button[type="submit"]');
    if (button && root.contains(button) && button.closest('form[action*="/cart/add"]')) validate(event);
  }, true);
  document.addEventListener('submit', event => {
    if (root.contains(event.target) && event.target.matches('form[action*="/cart/add"]')) validate(event);
  }, true);
  root.addEventListener('change', () => {
    root.querySelectorAll('[aria-invalid="true"]').forEach(input => input.removeAttribute('aria-invalid'));
    const error = root.querySelector('[data-mndj-photo-error]');
    if (error) error.hidden = true;
  });
  repair();
  new MutationObserver(repair).observe(root, {childList:true, subtree:true});
})();
